import {Box, HStack, SkeletonCircle, Text} from '@chakra-ui/react';
import {useAuth, useTranslation} from 'hooks';
import {useRouter} from 'next/router';
import {FC} from 'react';
import NextImageUI from 'ui/NextImage';

import {SidebarMobileMenu} from '../header/components';

export const Profile: FC = () => {
  const {t} = useTranslation();
  const {isAuthenticated, redirectToLoginPage, isLoading} = useAuth();
  const {asPath} = useRouter();

  if (isAuthenticated) return <SidebarMobileMenu />;
  if (isLoading && !isAuthenticated) return <SkeletonCircle size="12" />;

  return (
    <HStack mr="15px" onClick={() => redirectToLoginPage({redirectTo: asPath})} cursor="pointer">
      <Box boxSize="20px">
        <NextImageUI src="/icons/user.svg" alt="User" width={25} height={25} />
      </Box>
      <Text fontSize={['14px', '1rem']} fontWeight="600" cursor="pointer">
        {t('LOGIN_TITLE')}
      </Text>
    </HStack>
  );
};
